import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=f3a4faec&scoped=true&lang=pug&"
import script from "./ChannelItem.vue?vue&type=script&lang=js&"
export * from "./ChannelItem.vue?vue&type=script&lang=js&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&id=f3a4faec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3a4faec",
  null
  
)

export default component.exports